import React from "react";
import { useNavigate } from "react-router-dom";

export default function SelectMode() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-6 bg-[#efeeea]">
      <h1 className="text-2xl font-bold mb-6">診断モードを選んでね！</h1>

      <button 
        onClick={() => navigate("/private")}
        className="mb-4 px-6 py-3 bg-[#2f2301] text-white rounded-full hover:opacity-80 transition"
      >
        友達・家族と遊ぶ
      </button>

      <button 
        onClick={() => navigate("/business")}
        className="mb-4 px-6 py-3 bg-[#2f2301] text-white rounded-full hover:opacity-80 transition"
      >
        仕事の研修・イベントで遊ぶ
      </button>

      <button 
        onClick={() => navigate("/personal")}
        className="px-6 py-3 bg-[#2f2301] text-white rounded-full hover:opacity-80 transition"
      >
        自分の性格にぴったりのジャンルを診断
      </button>
    </div>
  );
}
